
/** 混入方法 ::: 
 *  @mixins mixFormItemTemplateProtocol 表单项协议
 */
import { mixFormItemTemplateProtocol } from "@/mixins/form_item/mix_form_item_template_protocol.js";

/** mixFormItemTemplateProtocol 协议实现
 *  @author 王汝鹏
 *  @version 2019-11-29
 */
export const mixFormItemTemplateProtocolRealize = {
  mixins:[mixFormItemTemplateProtocol],
  computed: {
    /** 协议数据 ::: 
     *  @return {Object} activeNode 激活节点
     *  @return {Object} formMap 表单项字典
     *  @return {String} expandFunction 扩展功能
     */
    form_item_template_store: { 
      get() { 
        let mix_rice_index_store = this.mix_rice_index_store;
        return {
          get activeNode() { return mix_rice_index_store.activeNode; },
          get formMap() { return mix_rice_index_store.formMap; },
          set formMap(newValue) { mix_rice_index_store.formMap = newValue; },
          get expandFunction() { return mix_rice_index_store.expandFunction; }
        }
      } 
    },
    /** 协议方法 ::: 
     *  @function form_item_template_event_config_manager 事件配置管理者
     *  @function form_item_template_form_node_manager 表单项节点管理者
     *  @function form_item_template_form_list_manager 表单列表管理者
     *  @author 王汝鹏
     *  @version 2019-11-28
     */
    form_item_template_event_config_manager: { get() { return this.eventConfigManager } },
    form_item_template_form_node_manager: { get() { return this.formNodeManager } },
    form_item_template_form_list_manager: { get() { return this.formListManager } }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/rice_index/mix_rice_index_protocol_realize.js